import * as React from 'react';
import { SVGProps } from 'react';

const IconToolsHoldFinSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11 14H5v-2h2V2h2v10h2v2Z"
      fill="var(--color-typo-primary)"
    />
  </svg>
);
export default IconToolsHoldFinSizeS;
